import auth from './auth';
import content from './content';
import contentInteraction from './content-interaction';

export default {
  'auth': auth,
  ...content,
  'content-interaction': contentInteraction,
};
